import { RootState } from "redux/rootReducer";

export const selectIsDownloadingCSVQuestion = (state: RootState) =>
  state.downloadCSVQuestion.loading;
export const csvDownloadErrorMessage = (state: RootState) =>
  state.downloadCSVQuestion.error;
export const downloadCSVQuestionResponse = (state: RootState) =>
  state.downloadCSVQuestion.downloadCSVQuestionResponse;
